<template>
  <div class="order-payment">
    <h6>支付</h6>
    <div class="content">
      <div class="title">产品信息</div>
      <PackageInformation :isPayment="true" :productData="productData" />
      <div class="action-bar">
        <div class="title">支付方式</div>
        <div class="ul">
          <div class="li" @click="payment(0)">
            <i class="iconfont icon-icon-zhifubao"></i>
            <span>支付宝</span>
          </div>
          <div class="li" @click="payment(1)">
            <i class="iconfont icon-icon-weixinzhifu"></i>
            <span>微信支付</span>
          </div>
          <div class="li" @click="payment(2)">
            <div class="top">
              <i class="iconfont icon-icon-gongkuanzhifu"></i>
              <span>公款支付</span>
            </div>
            <div class="bottom">到账后2个工作日内开通</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 是否完成实名认证回调弹框 -->
    <el-dialog
      custom-class="order-payment-dialog"
      width="600px"
      :visible="visible"
      @close="close"
    >
      <div class="content">
        <h6>支付结果</h6>
        <p>请在新打开的页面上进行支付，支付完成后再关闭此窗口</p>
        <el-button type="primary" @click="completeCertification"
          >已完成支付</el-button
        >

        <div>支付遇到问题可联系您的客户经理</div>
        <div>或 拨打 400-660-5995</div>
      </div>
    </el-dialog>
    <CorporatePayment
      v-if="corporatePaymentShow"
      :orderNo="productData.orderNo"
      @close="corporatePaymentClose"
      :amount="productData.realPaymentAmount"
    />
  </div>
</template>

<script>
import PackageInformation from './components/PackageInformation'
import CorporatePayment from './components/CorporatePayment'
import { getorderDetail, pendingPayment } from '@/utils/api/order'
export default {
  components: {
    PackageInformation,
    CorporatePayment,
  },
  data() {
    return {
      productData: {},
      visible: false,
      corporatePaymentShow: false,
      btnLoading: false,
    }
  },
  methods: {
    // 获取订单信息
    async getOrderInfo() {
      try {
        const res = await getorderDetail({
          orderNo: this.$route.params.orderNo || null,
        })
        if (res.rspResult.bizCode === 200) {
          this.productData = res.data
          this.productData.specList = this.productData.specs
        } else if (res.rspResult.bizCode === 5010 || res.rspResult.bizCode === 5040) {
          return this.$router.push({
            name: 'const-center-my-order',
          })
        }
      } catch (err) {
        console.error("❌ ~ file: order-payment.vue:87 ~ getOrderInfo ~ err:", err)
      }
    },

    // 去支付
    async payment(type) {
      if(this.btnLoading) return
      this.btnLoading = true
      let newPage = null
      if(type !== 2) newPage = window.open()
      // 支付前，校验订单状态
      try {
        const res = await pendingPayment({ orderNo: this.productData.orderNo })
        if (res.rspResult.bizCode === 200) {
          if (!res.data.value) {
            this.$message.error('订单状态发生变化') 
            // 订单状态非 未支付 && 未过期 跳到列表页
            newPage?.close()
            return this.$router.push({
              name: 'const-center-my-order',
            })
          }
        } else {
          return newPage.close()
        }
        this.btnLoading = false
      } catch(err) {
        console.error("❌ ~ file: order-payment.vue:111 ~ payment ~ err:", err)
        this.btnLoading = false
      }

      let routerName = null
      switch (type) {
        case 0:
          routerName = 'const-center-zfb-payment'
          break
        case 1:
          routerName = 'const-center-wx-payment'
          break
        default:
          // 这里弹出对公支付弹框
          break
      }

      if (routerName) {
        const router = this.$router.resolve({
          name: routerName,
        })
        newPage.location.href = router.href
        this.visible = true
      } else {
        // 对公
        this.corporatePaymentShow = true
      }
    },

    // 关闭弹框
    close() {
      this.completeCertification()
    },

    // 点击完成支付
    async completeCertification() {
      this.btnLoading = false
      try {
        const res = await pendingPayment({
          orderNo: this.productData.orderNo,
        })
        if (res.rspResult.bizCode === 200) {
          if (res.data.value) {
            // 未支付 且 未过期 ， 停留在当前页面
            this.visible = false
          } else {
            // 其余情况 都跳到列表页
            this.$router.push({
              name: 'const-center-my-order',
            })
          }
        } else {
          this.visible = false
        }
      } catch (err) {
        console.error("❌ ~ file: order-payment.vue:162 ~ completeCertification ~ err:", err)
        this.visible = false
      }
    },

    // 当对公弹框关闭时
    corporatePaymentClose() {
      this.corporatePaymentShow = false
    },
  },

  created() {
    this.getOrderInfo()
  },
}
</script>

<style lang="scss" scoped>
.order-payment {
  padding-top: 40px;
  > h6 {
    width: 1040px;
    margin: 0 auto;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
    letter-spacing: 0;
    height: 16px;
    margin-bottom: 20px;
  }
  > .content {
    width: 1040px;
    margin: 0 auto;
    > .title {
      height: 48px;
      line-height: 48px;
      background: #ffffff;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4f5d78;
      letter-spacing: 0;
      padding-left: 24px;
      margin-bottom: 2px;
    }
    .action-bar {
      margin-top: 8px;
      background: #ffffff;
      padding: 20px 24px;
      height: 160px;
      box-sizing: border-box;
      > .title {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #16181a;
        letter-spacing: 0;
        margin-bottom: 18px;
      }
      .ul {
        display: flex;
        .li {
          width: 160px;
          height: 68px;
          box-sizing: border-box;
          border: 1px solid #cfd5df;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-right: 20px;
          &:hover {
            background: #066eb71a;
          }
          > a {
            display: flex;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;
          }
          i {
            margin-right: 8px;
            color: #00a0ea;
            font-size: 20px;
          }
          span {
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #16181a;
          }
          &:nth-child(2) {
            i {
              color: #15ba11;
              font-size: 24px;
            }
          }
          &:last-child {
            display: block;
            padding-top: 18px;
            .top {
              display: flex;
              justify-content: center;
              height: 20px;
              line-height: 20px;
              i {
                color: #ff7f2a;
              }
            }
            .bottom {
              text-align: center;
              margin-top: 6px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              font-size: 12px;
              color: #4f5d78;
              height: 12px;
              line-height: 12px;
            }
          }
        }
      }
    }
  }
  ::v-deep &-dialog {
    el-dialog__body {
      padding: 32px;
    }
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        top: 30px;
        right: 32px;
        font-size: 20px;
        i {
          font-weight: bold;
        }
      }
    }
    .content {
      text-align: center;
      > h6 {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #16181a;
      }
      > p {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        height: 14px;
        color: #4f5d78;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      .el-button {
        width: 216px;
        height: 40px;
        background: #066eb7;
        border-radius: 4px;
        margin-bottom: 8px;
      }
      > div {
        text-align: center;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #98a3b7;
        margin-top: 8px;
      }
    }
  }
}
</style>
